import React from "react";
import { HeadingText } from "@/components/atoms/HeadingText/heading-text";
import Text from "@/components/atoms/Text/text";
import { ButtonLink } from "@/components/atoms/Link/link";
import HeroCarousel from "../Carousel/HeroCarousel";

interface JobBoardBannerProps {
  translations: Record<string, any>;
}

const jobBoardSlides = [
  "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
  "https://images.unsplash.com/photo-1582750433449-648ed127bb54?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
  "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
  "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
  "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
  "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
  "https://images.unsplash.com/photo-1580894732444-8ecded7900cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
  "https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
  "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
];

export const renderSlide = (slide: string, index: number) => (
  <div
    key={index}
    className="relative w-full md:h-[350px] h-[410px]"
  >
    {/* Background image */}
    <div
      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${slide})` }}
    />
    {/* Gradient overlay */}
    <div className="absolute inset-0 bg-gradient-to-r from-gray-950/80 to-gray-800/80" />
  </div>
);

const JobBoardBanner = ({ translations }: JobBoardBannerProps) => {
  return (
    <section className="relative w-full">
      <HeroCarousel
        slides={jobBoardSlides}
        renderSlide={renderSlide}
        contentPosition="static-overlay"
        staticContent={
          <div className="mx-auto max-w-screen-2xl px-4 sm:px-6 py-10 md:py-14 overflow-auto box-border">
            <div className="flex flex-col-reverse lg:flex-row items-center justify-between gap-10">
              {/* Text Content */}
              <div className="flex-1 w-full max-w-xl text-center lg:text-left">
                <HeadingText
                  level={2}
                  className="text-2xl sm:text-3xl font-bold leading-tight text-gray-50"
                >
                  {translations?.heading}
                </HeadingText>
                <Text className="mt-4 text-base sm:text-lg !text-gray-300">
                  {translations?.description}
                </Text>

                {/* CTA and Avatars */}
                <div className="mt-8 px-0 flex flex-col sm:flex-row sm:items-center sm:justify-start gap-4">
                  <ButtonLink
                    href="/dashboard/add-opportunity"
                    className="rounded-xl bg-blue-600 px-5 py-2.5 text-base font-medium text-white hover:bg-blue-700 transition"
                  >
                    {translations?.postJobButton}
                  </ButtonLink>

                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                    <div className="flex items-center justify-center">
                      {[
                        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=256&q=80",
                        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=256&q=80",
                        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=256&q=80",
                        "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=256&q=80",
                      ].map((src, i) => (
                        <img
                          key={i}
                          src={src}
                          alt=""
                          className="h-7 w-7 -ml-2 first:ml-0 rounded-full border-2 border-white object-cover dark:border-gray-700"
                        />
                      ))}
                      <span className="h-7 w-7 -ml-2 flex items-center justify-center rounded-full border-2 border-white bg-blue-100 text-xs text-blue-600 dark:border-gray-700">
                        +4
                      </span>
                    </div>
                    <span className="text-sm font-medium text-blue-600 dark:text-blue-300 text-center sm:text-left">
                      {translations?.reachProfessionals}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        autoPlay={true}
        interval={3000}
      />
    </section>
  );
};

export default JobBoardBanner;
